module.exports = __webpack_public_path__ + "kolibri-logo.svg?625360a31b0628f83d4ca2ef861dbd30";